export default __webpack_public_path__ + "static/media/3.d07515d0.png";